import { MongoObservable } from 'meteor-rxjs';
import { OptIn } from '../models/optIn';

export const OptIns = new MongoObservable.Collection<OptIn>('optins');

OptIns.allow({
  insert: function () {
    return false;
  },
  update: function () {
    return false;
  },
  remove: function () {
    return false;
  },
});
